module.exports = __webpack_public_path__ + "a13f404cdba51a4c725636ab793d039f.png";